export type Helpers = {
  apiURL: (path: string) => string;
  storageURL: (path: string) => string;
};
export default defineNuxtPlugin((nuxtApp) => {
  const $helpers = {
    apiURL: (path: string) => {
      return [nuxtApp.$config.public.baseUrl, path]
        .filter((v) => v)
        .map((part) => (part as string).replace(/^\//, ""))
        .join("/");
    },
    storageURL: (path: string) => {
      return [nuxtApp.$config.public.storageBaseURL, path]
        .filter((v) => v)
        .map((part) => (part as string).replace(/^\//, ""))
        .join("/");
    },
    scrollToClosestError() {
      const el = document.querySelector(".error");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
  };
  nuxtApp.provide("helpers", $helpers as Helpers);
});
